import { render } from "./DiagnosisManagementDetail.vue?vue&type=template&id=59f7af59&scoped=true"
import script from "./DiagnosisManagementDetail.vue?vue&type=script&lang=js"
export * from "./DiagnosisManagementDetail.vue?vue&type=script&lang=js"

import "./DiagnosisManagementDetail.vue?vue&type=style&index=0&id=59f7af59&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f7af59"]])

export default __exports__